import getPinStyle from '../getPinStyle'

export function applyFeatureStyle(feature: any, options?: {
    selected?: boolean
    hover?: boolean
}) {
    const type = feature.get('type')
    const variant = feature.get('variant')
    const label = feature.get('label')

    feature.setStyle(
        getPinStyle(type, {
            variant,
            label,
            selected: options?.selected,
            hover: options?.hover,
        })
    )
}